import axios from "axios";
import {dictionaryUtils} from "../../utils";

export const listWords = (cursor, limit, success, failure) => {
    let url = "/api/v1/internal/dictionary/list?limit=" + limit;

    if (cursor) {
        url += "&cursor=" + cursor;
    }

    axios.get(url)
    .then(response => {
        const json = response.data;

        json.words = json.words.map(dictionaryUtils.sanitizeWord);

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};

export const saveWord = (info, success, failure) => {
    const url = "/api/v1/internal/dictionary/word";

    axios.post(url, {
        word: info.word,
        definitions: info.definitions,
        sentences: info.sentences,
    })
    .then(response => {
        const json = response.data;
        const sanitized = dictionaryUtils.sanitizeWord(json);

        success(sanitized);
    })
    .catch(err => {
        failure(err);
    });
};

export const createWord = (word, success, failure) => {
    const url = "/api/v1/internal/dictionary/info";

    axios.post(url, {
        word: word,
    })
    .then(response => {
        const json = response.data;
        const sanitized = dictionaryUtils.sanitizeWord(json);

        success(sanitized);
    })
    .catch(err => {
        failure(err);
    });
};

export const deleteWord = (word, success, failure) => {
    const url = `/api/v1/internal/dictionary/${word}/`;

    axios.delete(url)
    .then(response => {
        success(word);
    })
    .catch(err => {
        failure(err);
    });
};
